import { IconParkName } from 'packages/components/GrowpIcon/types'
import {
  FieldDomainEnum,
  FieldTypeEnum,
  MeteDataRes,
  QuestionnaireReq,
  QuestionnaireReqColumn,
  TaskReq,
} from 'packages/sdks-next/growp'
import { AnyValueObj } from 'packages/types'

export interface ButtonConfig {
  id?: number
  groupId?: number
  type: FieldTypeEnum
  iconName: IconParkName
  text: string
  label?: string
  require?: boolean
  editable?: boolean
  description?: string
  metadata?: MeteDataRes
  options?: Option[]
  isUserField?: boolean
  children?: ButtonConfig[]
  name?: string
}

export interface BaseComponentsConfig {
  groupName: string
  buttonConfigs: ButtonConfig[]
}

export interface QuestionnaireContextParam {
  task: TaskReq
  questionnaires: ReqWithMetaData[]
  setQuestionnaires: (val: ReqWithMetaData[]) => void
  activeItemIndex: number | undefined
  setActiveItemIndex: (arr?: number) => void
  domain: FieldDomainEnum
  userFieldsConfig: BaseComponentsConfig[]
  setIsPreview: (status: boolean) => void
  allGroupIds?: number[]
  structIsChange?: () => void
}

export enum DateTypeEnum {
  Time = 'time',
  Date = 'date',
}

export enum SelectTypeEnum {
  Checked = 'checked',
  DropDown = 'dropDown',
}

// 弃用，暂时勿删， 用MetaDataRes替代
export type MetaData = {
  // 多选类型里表示最多可选择多少个，文件类型表示最多上传文件的个数
  maxCount?: number | null
  // 多选类型里表示最少可选择多少个，文件类型表示最少上传文件的个数
  minCount?: number | null
  // 附件类型文件上传大小限制
  fileSizeLimit?: number | null
  // 是否显示题目说明
  showDescription?: boolean | null
  // 数字类型精确到小数点后几位
  precision?: number | null
  // 日期类型
  dateType?: DateTypeEnum | null
  // 单选多选类型 添加其他选项后是否必填
  otherRequire?: boolean | null
  // 单选多选 显示类型
  selectType?: SelectTypeEnum | null
  // 原始name
  originLabel?: string | null
}

export type Option = {
  label: string
  value: string | number
  id?: number
  name: string
}

export type ReqWithMetaData = Omit<QuestionnaireReq, 'options'> & {
  metadata?: MeteDataRes
  options?: Option[]
  isUserField?: boolean
  children?: ReqColumnWithMetaData[]
  id?: number
  groupId?: number
  name?: string
  index?: number
  uuid?: string
}

export type ReqColumnWithMetaData = Omit<QuestionnaireReqColumn, 'options'> & {
  metadata?: MeteDataRes
  children?: undefined
  options?: Option[]
  isUserField?: boolean
  id?: number
  groupId?: number
  name?: string
  index?: number
}

export interface DragContextParam {
  dragDisabled: boolean
  onChangeDragDisabled: (status: boolean) => void
}

export interface FormContextParam {
  formValues: AnyValueObj
  setFormValues: (v: object) => void
  setFinalFormValues?: (v: object, o: AnyValueObj) => void
  otherInfo: AnyValueObj
  setOtherInfo: (v: object) => void
  setFinalOtherValues?: (v: object) => object
}
